import { mdiPlus, mdiSync, mdiDelete } from '@mdi/js'

export default {
  'freshvuehistory-event-USER_EMPLOYMENTCONTRACT_CREATED': mdiPlus,
  'freshvuehistory-event-USER_EMPLOYMENTCONTRACT_UPDATED': mdiSync,
  'freshvuehistory-event-USER_EMPLOYMENTCONTRACT_DELETED': mdiDelete,
  'freshvuehistory-event-USER_EMPLOYMENTCONTRACTADDENDUM_CREATED': mdiPlus,
  'freshvuehistory-event-USER_EMPLOYMENTCONTRACTADDENDUM_UPDATED': mdiSync,
  'freshvuehistory-event-USER_EMPLOYMENTCONTRACTADDENDUM_DELETED': mdiDelete,
  'freshvuehistory-event-USER_EMPLOYMENTDETAIL_CREATED': mdiPlus,
  'freshvuehistory-event-USER_EMPLOYMENTDETAIL_UPDATED': mdiSync,
  'freshvuehistory-event-USER_EMPLOYMENTDETAIL_DELETED': mdiDelete
}
